 
<template>   
    <div class="modal fade" :id="kt_atualizar" tabindex="-1" aria-hidden="true" >  
        <div class="modal-dialog" style="max-width:1200px;">  
            <div class="modal-content" style="min-height: 450px;">  
                <div class="modal-header"> 
					<h2>Atualizar Endereço</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" >
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg" />
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y m-5">
                    <div class="row g-6 g-xl-12">  
                        <div class="col-12 col-sm-6 col-lg-4">  
                            <div class="form-group"> 
                                <label for="descricao">CEP (somente número):</label> 
                                <input  required type="number" name="cep" class="form-control" v-model="formulario.cep" >  
                            </div>
                        </div> 
                        <div class="col-12 col-sm-3 col-lg-2" style="padding-top:20px"> 
                            <a class="btn btn-warning" @click="buscarCEP"> <i class="fa fa-search"></i> Buscar</a> 
                        </div>
                        <div class="ccol-12 col-sm-3 col-lg-2" style="padding-top:32px"> 
                            <a target="_blank" href="http://www.buscacep.correios.com.br/sistemas/buscacep/">Não sei meu CEP</a> 
                        </div> 
                        <ListaCampoForm :campos="campos" :formulario="formulario"   ></ListaCampoForm>  
                    </div>  
				</div>  
                <div class="modal-footer"  > 
                    <BotaoSalvar  @click="salvar" :processando="processando" titulo="Atualizar"></BotaoSalvar>   
				</div> 
			</div> 
		</div> 
	</div> 
</template>

<script lang="ts"> 

    import CadastroInline from '@/components/aplicacao/CadastroInline.vue';    
    import Multiselect from '@vueform/multiselect'
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue'; 
    import EnderecoService  from '@/service/v10/sigap/EnderecoService';  
    import { Options, Vue  } from "vue-class-component";  
    import {  Endereco } from "./Endereco";
	import $ from "jquery"  
    import axios from "axios";
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
	  
    @Options({
        name: "EnderecoEdicao",
        components: {  CadastroInline  , Multiselect, ListaCampoForm, BotaoSalvar },  
        emits: [  'endereco-militar-alterado'],  
    }) 
    export default class EnderecoEdicao extends Vue {
         
        public endereco_correios:any = null ;  
        @Prop( ) readonly kt_atualizar!: any  
        @Prop( ) readonly modelo!: any
        
        public modal = '';
        public editando = false;
        public processando = false; 
        public service:any = null ;  
        public formulario: any  = { } ;   
        public campos: Array<any> = [ ];


        public modeloAlterado(){   
            if(this.modelo != null ){
                this.editando = false ;  
                this.formulario = {   }; 
                this.formulario = JSON.parse(JSON.stringify(this.modelo)); 
                this.formulario.usuarioid = this.formulario != null ? this.formulario.usuarioid.toString(): '';
                this.formulario.numero = this.formulario != null ? this.formulario.numero.toString(): '';
                if(this.formulario.cep){
                    this.formulario.cep =  this.formulario.cep.toString()
                } 
            } 
        }
  
        created() { 
            this.service = new EnderecoService();  
            this.campos =  Endereco.campos(); 
        }
     
        @Watch('modelo')
		exameAtualizada(newVal: string) { 
            this.modeloAlterado(); 
		}
 
        get hasPermissao(   ): boolean {
            return true;
        }
   
        public getdados(){  
            let dados = JSON.parse(JSON.stringify(this.formulario)); 
            return dados;
        }
 
        public sucesso(){  
            this.$emit("endereco-militar-alterado", null);   
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        } 

        public editar(){ 
            if( this.hasPermissao ){
                this.editando = !this.editando ;  
            }
            else {
                 this.editando = false ;
            } 
        }
 
        public salvar(){
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.service.updateMy(  this.modelo.id, dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Atualizado com sucesso! ' ,  response.message  );
                    this.sucesso();  
                    this.formulario = {};
                    this.processando = false ; 
                    this.editando = false ;
                }) 
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });  
            }, 100); 
        } 
 
        buscarCEP( ) { 
            if(this.formulario.cep.length == 8){ 
                axios.get( "https://viacep.com.br/ws/" + this.formulario.cep + "/json/" , {  }  )
                .then(response => {    
                    this.endereco_correios =   response.data;
                    this.formulario.logradouro =  this.endereco_correios.logradouro; 
                    this.formulario.bairro =  this.endereco_correios.bairro; 
                    this.formulario.cidade =  this.endereco_correios.localidade; 
                    this.formulario.uf =  this.endereco_correios.uf;   
                })
                .catch(error => { 
                    console.log('');
                }) 
            } 
        }
    } 
</script>
